module.exports = __webpack_public_path__ + "static/cabina-de-conductor---cupula-4568720061b06887a9061b3a54ccbabe.jpg";